import { Box, styled, Typography } from '@mui/material';

export const StyledStack = styled(Box)({
  display: 'inline-flex',
});

export const StyledDistroDark = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: 16,
  color: theme.palette.grey[900],
}));

export const StyledDistroLight = styled(StyledDistroDark)(({ theme }) => ({
  color: theme.palette.grey[50],
}));

export const StyledPlusText = styled(Typography)(({ theme }) => ({
  fontWeight: 900,
  fontSize: 16,
  color: theme.palette.secondary.dark,
}));

export const StyledPlusTextLight = styled(StyledPlusText)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const StyledPlusSign = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 900,
  color: theme.palette.secondary.dark,
}));
StyledPlusSign.defaultProps = {
  variant: 'caption',
};

export const StyledPlusSignLight = styled(StyledPlusSign)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));
StyledPlusSignLight.defaultProps = {
  variant: 'caption',
};
